<template>
	<div class="hello">
		<div style="text-align:center;padding:30px 10px 20px 10px;">
			<i class="weui-icon-waiting icon weui-icon-success" id="icon"></i>
			<p style="font-size:22px;color:#555;" id="iconText">已通过安全检测</p>
			<p style="font-size:15px;color:#999;" id="subText">请点击下方按钮，选择线路前往主页</p>
		</div>
		<div class="actions" id="goHome">
			<a href="http://13297.kp318wch0q.shop:18111" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">①线路→点击前往</a>
			<!-- <a href="http://13297.kp318wch0q.shop:16222" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">②线路→点击前往</a> -->
			<a href="http://13297.kp318wch0q.shop:18222" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">②线路→点击前往</a>
			<a href="http://13297.kp318wch0q.shop:18333" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">③线路→点击前往</a>
<!-- 			<a href="http://13297.kp318wch0q.shop:16555" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">①线路→点击前往</a>
			<a href="http://13297.kp318wch0q.shop:16666" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">②线路→点击前往</a>
			<a href="http://13297.kp318wch0q.shop:16888" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">③线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17444" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑧线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17555" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑨线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17666" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">⑩线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17777" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">⑪线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17888" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑫线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:17999" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑬线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18111" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑭线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18222" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">⑮线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18333" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑯线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18444" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">⑰线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18555" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑱线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18888" class="weui-btn weui-btn_primary" id="openSchemeLink" style="">⑲线路→点击前往</a> -->
			<!-- <a href="http://13297.kp318wch0q.shop:18999" class="weui-btn weui-btn_primary" id="openSchemeLink1" style="">⑳线路→点击前往</a> -->
			<a href="" class="weui-btn weui-btn_primary1" id="openSchemeLink1" style="">移动网络»防止移动端无法正常访问及防劫持解决方案</a>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		props: {
			msg: String
		}
	}
</script>

<style>
	/* 在小屏幕上的样式 */
	@media screen and (max-width: 768px) {
		/* 样式规则 */
		.hello{
			width: 100%;
			margin: 0 auto;
			background-color: #fff;
		}
	}

	/* 在中等屏幕上的样式 */
	@media screen and (min-width: 768px) and (max-width: 1024px) {
		/* 样式规则 */
		.hello{
			width: 65%;
			margin: 0 auto;
			background-color: #fff;
		}
	}

	/* 在大屏幕上的样式 */
	@media screen and (min-width: 1024px) {
		/* 样式规则 */
		.hello{
			width: 65%;
			margin: 0 auto;
			background-color: #fff;
		}
	}

	body {
		margin: 0;
		background: #f0f5f9;
	}

	.wxtip {
		background: rgba(0, 0, 0, 0.5);
		text-align: center;
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 998;
		display: none;
	}


	.wxtip-txt {
		margin-top: 107px;
		color: #fff;
		font-size: 16px;
		line-height: 1.5;
	}


	@font-face {
		font-weight: normal;
		font-style: normal;
		font-family: "weui";
		src: url('data:application/octet-stream;base64,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') format('truetype');
	}


	[class^="weui-icon-"],
	[class*=" weui-icon-"] {
		display: inline-block;
		vertical-align: middle;
		font: normal normal normal 14px/1 "weui";
		font-size: inherit;
		text-rendering: auto;
		-webkit-font-smoothing: antialiased;

		&:before {
			display: inline-block;
			margin-left: .2em;
			margin-right: .2em;
		}
	}

	.weui-icon-waiting:before {
		content: "\EA09";
	}

	.weui-icon-success:before {
		content: "\EA04"
	}

	.weui-btn_primary {
		background-color: #1AAD19;
	}

	.weui-btn_primary1 {
		background-color: #4763b2;
	}

	.weui-btn {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		text-decoration: none;
		color: #FFFFFF;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		overflow: hidden;
		margin-bottom: 10px;
		white-space: nowrap;
	}

	.weui-btn_default {
		color: #000000;
		background-color: #F8F8F8;
	}

	.weui-icon-waiting {
		color: #10AEFF;
	}

	.weui-icon-success {
		color: #1AAD19;
	}

	.icon {
		font-size: 93px;
		margin: 20px auto;
	}

	.actions {
		padding: 10px 10px;
	}

	.footer {
		position: absolute;
		bottom: 0;
		width: 100%;
		text-align: center;
		color: #999;
		font-size: 12px;
	}

	* {
		margin: 0;
		padding: 0;
	}

	img {
		max-width: 100%;
		height: auto;
	}
</style>